import AuthClient from './authClient'

export default AuthClient
